import {AbstractCommand} from "../abstract-command.command";

export class ReportHitConfirmationCommand extends AbstractCommand {
  constructor(public readonly confirm: boolean) {
    super('reportHitConfirmation');
  }
}
